import React from 'react';
import { getVariantHeroImages } from '../../helpers';
import { StyledHeroImage } from './HeroImage.styles';

const HeroImage = ({ item, children }) => {
    const variantImage = getVariantHeroImages(item);
    const imageRatio = '16-9';

    return (
        <StyledHeroImage
            src={variantImage.src}
            srcSet={variantImage.srcSets.join(',')}
            sizes={variantImage.sizes}
            ssr={true}
            alt={variantImage.altText}
            imageRatio={imageRatio}
        >
            {children}
        </StyledHeroImage>
    );
};

export default HeroImage;
